import { createSlice } from "@reduxjs/toolkit";
import { uploadDocuments } from "../documentUploadApi";

const uploadDocumentsSlice = createSlice({
  name: "uploadDocuments",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handle fetchCommunityData cases
      .addCase(uploadDocuments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadDocuments.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(uploadDocuments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});
export default uploadDocumentsSlice.reducer;
